import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() titre: string;
  @Input() hasBackground = false;
  @Output() retour = new EventEmitter<void>();
  @Input() boutonRetourVisible = false;
  @Input() boutonRetourSansFondBlanc = false;

  public returnAction() {
    this.retour.emit();
  }
}
